export default function isHeadlessBrowser() {
    const userAgent = navigator.userAgent || '';
    const isHeadlessUA = /HeadlessChrome/.test(userAgent);
    const isWebDriver = navigator.webdriver;

    return isHeadlessUA || isWebDriver;
}